import cx from 'classnames'
import _ from 'lodash'
import React, { Component } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { I18n } from 'react-redux-i18n'

import LoaderIcon from '../../icons/loading.svg'

import '../../style/compositions.less'

import Composition from './Composition'
import FilterTags from './FilterTag'
import Movie from './Movie'
let headerHeight = 60

class CompositionList extends Component {

  componentWillMount () {
    this.props.fetchCompositions()
  }

  componentDidMount(){
    if(document.getElementById('inbox-search-header')){
      headerHeight = document.getElementById('inbox-search-header').offsetHeight
    }
  }

  toggleExpand (cplId) {
    let cplIds = _.cloneDeep(this.props.compositions.cplIds)
    if (cplIds.includes(cplId)) {
      cplIds = _.remove(cplIds, cId => cId !== cplId)
    } else {
      cplIds.push(cplId)
    }

    this.props.updateCplIds(cplIds)
  }

  getCompositions () {
    const{
       compositions: {compositions, fetchInProgress, cplIds},
       sendKDMEmail,
       downloadKDMs,
       loadTheatreDetails,
       user
    } = this.props

    if (!compositions.length && !fetchInProgress) {
      return (
        <div>
         <p className="qw-center qw-font-size-large qw-line-height-large qw-py-medium">
          {I18n.t('compositions.no_compositions')}
         </p>
        </div>
     )
    }
    return compositions.map((composition, idx) => {
      return (
        composition.resourceType === 'composition' ?
          <Composition
            key={idx} composition={composition} showModal={this.props.showModal}
            sendKDMEmail={sendKDMEmail} downloadKDMs={downloadKDMs}
            expand={cplIds.includes(composition.id)}
            toggleExpand={this.toggleExpand.bind(this, composition.id)}
            loadTheatreDetails={loadTheatreDetails}
            user={user}
          />
          :
          <Movie
            key={idx} composition={composition} showModal={this.props.showModal}
            sendKDMEmail={sendKDMEmail} downloadKDMs={downloadKDMs} cplIds={cplIds}
            toggleExpand={this.toggleExpand.bind(this)} loadTheatreDetails={loadTheatreDetails}
            user={user}
            openMovieModal={(value) => this.props.openMovieModal(value)}
          />
      )
    })
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.selectedTheatres !== this.props.selectedTheatres) {
      this.props.fetchCompositions(true)
    }
  }

  fetchData () {
    this.props.fetchCompositions()
  }

  renderLoading (initialLoad = false) {
    return (
      <div
        className={cx('qw-flex qw-items-center qw-justify-center', {'full-height': initialLoad})}>
        <LoaderIcon className="qw-icon-xxx-large"/>
      </div>
    )
  }

  render () {
    const {
      compositionFilters,
      toggleTheatreFilter,
      compositions: {hasMore, dataReceived}
    } = this.props
    return (
      <InfiniteScroll
        next={() => this.fetchData()}
        hasMore={hasMore}
        loader={this.renderLoading()}
        height={window.innerHeight - headerHeight}>
        <FilterTags
          compositionFilters={compositionFilters}
          toggleTheatreFilter={toggleTheatreFilter}
        />
        {!dataReceived && this.renderLoading(true)}
        {this.getCompositions()}
      </InfiniteScroll>
    )
  }
}

export default CompositionList



// WEBPACK FOOTER //
// ./src/app/components/compositions/List.js